<template>
  <div class="container">
    <div class="brand-content">
      <img src="https://static.bienparabien.com/apps/img/logo_gradiente.png" alt="Logo BpB" width="200px">
      <h1>¡Bienvenido!</h1>
      <p>Ingresa aquí tus datos para poder ingresar a tu portal.</p>
    </div>
    <div class="login">
      <form @submit="login">
        <div class="form-group">
          <label for="login-email"><small>Correo electrónico:</small></label>
          <input v-model="credenciales.usuario" type="email" class="form-control" id="login-email" aria-describedby="emailHelp">
        </div>
        <div class="form-group">
          <label for="login-password"><small>Contraseña:</small></label>
          <input v-model="credenciales.password" type="password" class="form-control" id="login-password">
        </div>
        <button type="submit" class="btn btn-bpb-primary col-sm-12">Entrar</button>

        <div class="password">
          <router-link :to="{name:'recuperar-contrasena'}" class="nav-link">
            Recuperar contraseña
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script type="text/javascript">
  import api from '@/api/account'
  import apiCliente from '@/api/clientes'

  export default {
    data: function() {
      return {
        credenciales: {
          usuario: null
          ,password: null
        }
      }
    }
    ,methods: {
      login: async function(e) {
        e.preventDefault();

        try {
          let res = (await api.login(this.credenciales)).data;

          this.$store.commit('set',{auth: res});

          if (res.user.password_reset == 1)
            return this.$router.push({name: 'definir-contrasena'});

          let cliente = (await apiCliente.obtener_cliente()).data;

          this.$store.commit('set', {cliente});

          this.$router.push({name: 'mis-creditos'});
        }catch(e) {
          this.$log.error('err',e);
          this.$helper.axios_error(e);
        }
      }
    }
  }
</script>